export default __webpack_public_path__ + "static/9-7c007263bafdd61457d16bc037a66e41.jpg";